import type { IDownloadCompleted } from "../global";
import htmx from "htmx.org";
import { AlpineComponent } from "@nxtlvlsoftware/alpine-typescript";
import { bindHtmxUpdate } from "../handlers/updates";

export default class ExplorerUpload extends AlpineComponent {
  constructor() {
    super();
  }

  init() {
    bindHtmxUpdate(this.$el)
  }

  onNewDocument(e: CustomEvent<IDownloadCompleted>) {
    const { files } = e.detail;
    const fileInput = this.$refs.fileInput as HTMLInputElement;
    fileInput.files = files;

    if (fileInput.files && fileInput.files.length > 0) {
      htmx.trigger(this.$el, "submit", {});
    }
  }

  onRefresh() {
    const fileInput = this.$refs.fileInput as HTMLInputElement;
    fileInput.files = null;
    htmx.trigger(this.$el, "submit", {});
  }
}
